export default __webpack_public_path__ + "static/branch1-daf3ff3d2bcf09a9fe3f0d99f4b72522.png";